import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const TermsOfService: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Terms of Service" pagesub="Terms of Service" />
            <section className="legal-content pt-120 pb-120">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="legal-content-wrap">
                      <div className="sec-title sec-title-center about-sec-title about-sec-title-two mb-60">
                        <span className="sub-title mb-10">Legal</span>
                        <h2 className="title">Terms of Service</h2>
                      </div>

                      <p className="legal-meta" style={{ textAlign: "center", color: "rgba(255,255,255,0.5)", marginBottom: 60 }}>
                        Last updated: April 20, 2026
                      </p>

                      <div className="legal-section">
                        <h3 className="legal-heading">1. Agreement to Terms</h3>
                        <p className="legal-text">
                          By accessing or using the services provided by TorqAI Technologies Inc. ("TorqAI," "we," "us," or "our"),
                          including our website at torqai.ca and all related AI products (CAPRO, VAPRO, HAPRO, SAPRO, TAPRO, and INPRO),
                          you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not
                          access or use our Services.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">2. Description of Services</h3>
                        <p className="legal-text">
                          TorqAI provides AI-powered business automation solutions, including but not limited to voice agents,
                          social media management, hiring automation, sales outreach, training simulations, and data analytics.
                          Our Services are offered on a subscription basis with various pricing tiers as described on our Pricing page.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">3. Account Registration</h3>
                        <p className="legal-text">
                          To access certain features of our Services, you may be required to create an account. You agree to provide
                          accurate, current, and complete information during the registration process and to update such information
                          to keep it accurate, current, and complete. You are responsible for safeguarding your account credentials
                          and for all activities that occur under your account.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">4. Acceptable Use</h3>
                        <p className="legal-text">
                          You agree not to use our Services to: (a) violate any applicable law, regulation, or third-party rights;
                          (b) transmit any harmful, threatening, abusive, or otherwise objectionable content; (c) attempt to gain
                          unauthorized access to any part of the Services or related systems; (d) interfere with or disrupt the
                          integrity or performance of the Services; or (e) use the Services for any purpose other than their
                          intended business automation functions.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">5. Intellectual Property</h3>
                        <p className="legal-text">
                          All content, features, and functionality of the Services — including but not limited to text, graphics,
                          logos, icons, images, audio clips, software, and compilations — are the exclusive property of TorqAI
                          Technologies Inc. and are protected by Canadian and international copyright, trademark, patent, and
                          other intellectual property laws.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">6. Payment and Billing</h3>
                        <p className="legal-text">
                          All prices are listed in Canadian Dollars (CAD). You agree to pay all fees associated with your selected
                          subscription plan. Payments are due on a recurring monthly or annual basis, depending on your chosen
                          billing cycle. We reserve the right to change our pricing with 30 days' notice. Failure to pay may
                          result in suspension or termination of your account.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">7. Cancellation and Refunds</h3>
                        <p className="legal-text">
                          You may cancel your subscription at any time. Upon cancellation, your access will continue until the
                          end of your current billing period. We offer a 7-day free trial for new users; cancellation during
                          the trial period will not result in any charges. Refunds for paid subscriptions are handled on a
                          case-by-case basis at our discretion.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">8. Data and Privacy</h3>
                        <p className="legal-text">
                          Your use of the Services is also governed by our Privacy Policy, which is incorporated into these
                          Terms by reference. By using our Services, you consent to the collection, use, and disclosure of
                          your information as described in the Privacy Policy.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">9. Limitation of Liability</h3>
                        <p className="legal-text">
                          To the fullest extent permitted by applicable law, TorqAI Technologies Inc. shall not be liable for
                          any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or
                          revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other
                          intangible losses resulting from your use of the Services.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">10. Disclaimer of Warranties</h3>
                        <p className="legal-text">
                          The Services are provided "as is" and "as available" without warranties of any kind, whether express
                          or implied, including but not limited to implied warranties of merchantability, fitness for a particular
                          purpose, and non-infringement. TorqAI does not warrant that the Services will be uninterrupted,
                          error-free, or completely secure.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">11. Governing Law</h3>
                        <p className="legal-text">
                          These Terms shall be governed by and construed in accordance with the laws of the Province of Ontario
                          and the federal laws of Canada applicable therein, without regard to conflict of law principles.
                          Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts
                          located in Toronto, Ontario.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">12. Changes to These Terms</h3>
                        <p className="legal-text">
                          We reserve the right to modify these Terms at any time. We will notify users of material changes
                          by posting the updated Terms on our website and updating the "Last updated" date. Your continued
                          use of the Services after such changes constitutes your acceptance of the new Terms.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">13. Contact Information</h3>
                        <p className="legal-text">
                          If you have any questions about these Terms of Service, please contact us at:
                        </p>
                        <p className="legal-text">
                          <strong>TorqAI Technologies Inc.</strong><br />
                          30 Charles St W, Toronto, ON<br />
                          Email: <a href="mailto:info@torqai.ca" style={{ color: "var(--color-primary)" }}>info@torqai.ca</a><br />
                          Phone: <a href="tel:+14374475333" style={{ color: "var(--color-primary)" }}>+1 437 447 5333</a>
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default TermsOfService;
